module.exports = __webpack_public_path__ + "static/media/mockup-iphone-ipad.bbb91c2b.png";